// A fresh save slice (phase D joined): a save from before a module joined its scene gets `{ fresh: true }` for that
// module's slice from the sim slice's migration (schema.ts, v5 → v6), and the module's deserialize puts its state back
// to what its build made (a new game's), whatever the page had played before the load.

/** The marker a migration writes for a module that wasn't in the save. */
export const FRESH_SLICE = { fresh: true } as const;

/** Whether a slice's data is the fresh marker. */
export function isFresh(data: unknown): boolean {
  return typeof data === "object" && data !== null && (data as { fresh?: unknown }).fresh === true;
}
